<template>
  <div>

    <body data-anchor="pagetop" class="home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container" style="overflow-y: unset;">
      <navbar follow="st-Header" imgSrc="../../../../static/img/landing/logo_black.png" searchImgSrc="../../../../static/img/landing/search_black.png"></navbar>
      <div class="st-FixedPoint"></div>
      <div class="st-MainContainer">
        <main class="st-MainContents" style="padding-top: 120px;">
          <header class="company-PageTitle">
            <div class="company-PageTitle_Inner">
              <h1 data-appear="" class="company-PageTitle_Inner_Title">
                <span class="company-PageTitle_Logo"><b>RECRUIT</b></span>
                <span class="company-PageTitle_Title"><b>採用情報</b></span>
              </h1>
              <div class="sw-parallax">
                <div class="sw-parallax_outer js-parallax_outer">
                  <div class="sw-parallax_inner">
                    <div class="sw-parallax_block js-parallax_block">
                      <div class="sw-parallax_target">
                        <div class="company-PageTitle_Slide">
                          <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image1" style="background: url(../../../../static/img/landing/childpageimg2.png) 20%/cover no-repeat;"></div>
                          <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image2" style="background: url(../../../../static/img/landing/childpageimg2.png) 20%/cover no-repeat;"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>
        </main><!-- /.st-MainContents -->
        <section class="company-Profile">
            <div class="company-Profile_Inner">
              <h3 class="sw-Section_HeaderS" data-appear="">
                <span class="sw-Section_HeaderS-en"><b>JOIN US</b></span>
                <span class="sw-Section_HeaderS-ja"><b>採用情報</b></span>
              </h3>
              <div class="company-Profile_List" data-appear="">
                <dl>
                  <dt>初任給</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <a href="/">
                        <p class="company-Profile_List-text"> 修士  210,000<br>
                                                              大学卒業  200,000<br>
                                                              高専卒 190,000</p>
                      </a>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>諸手当</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <a href="/">
                        <p class="company-Profile_List-text">家族手当、単身赴任手当、通勤手当、時間外手当など</p>
                      </a>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>賞与</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <p class="company-Profile_List-text">年2回（7月,12月） <br class="sp"></p>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>昇給</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <p class="company-Profile_List-text">年1回（4月） <br class="sp"></p>
                    </div>
                  </dd>
                </dl>
                <dl class="business">
                  <dt>勤務時間</dt>
                  <dd>
                    <div class="company-Profile_List-block">
                      <p class="company-Profile_List-text">本社08:00-17:00 工場08:00-17:00</p>
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </section>
        <div class="st-Breadcrumbs">
          <ul class="st-BreadcrumbsList" itemscope="itemscope" itemtype="https://schema.org/BreadcrumbList">
            <li class="st-BreadcrumbsList_Item" itemprop="itemListElement" itemscope="itemscope" itemtype="https://schema.org/ListItem">
              <a class="st-BreadcrumbsList_Item-link" href="/">
                <p itemprop="item" aria-current="page"><span itemprop="name">ホーム</span></p>
              </a>
            </li>
            <li class="st-BreadcrumbsList_Item" itemprop="itemListElement" itemscope="itemscope" itemtype="https://schema.org/ListItem">
              <p itemprop="item" aria-current="page"><span itemprop="name">採用情報</span></p>
            </li>
          </ul>
        </div>
      </div>
      <copyright></copyright>
    </body>
  </div>
</template>
<style />
<script type="text/javascript">
import copyright from './../copyright'
import navbar from './../navbar'

export default {
  components: { copyright, navbar },
  data: function () {
    return {
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      $('.company-PageTitle_Inner_Title').eq(0).addClass('appear')
      $('.company-Message_Inner').eq(0).addClass('appear')
      $('.sw-Section_HeaderS').eq(0).addClass('appear')
      // element.offsetHeight
      $(document).scroll(() => {
        let scroH = $(document).scrollTop()
        let viewW = $(window).width()
        console.log(scroH)
        if (scroH > 50) {
          $('.st-Header').addClass('is-follow')
          $('.st-Footer_Pagetop').addClass('is-follow')
        } else {
          $('.st-Header').removeClass('is-follow')
          $('.st-Footer_Pagetop').removeClass('is-follow')
        }

        if (viewW > 769) {
          if (scroH >= 300) {
            $('.company-PageTitle_Inner_Title').eq(0).removeClass('appear')
          } else {
            $('.company-PageTitle_Inner_Title').eq(0).addClass('appear')
          }
          if (scroH >= 700) {
            $('.sw-Section_HeaderS').eq(0).removeClass('appear')
          } else {
            $('.sw-Section_HeaderS').eq(0).addClass('appear')
          }
          if (scroH >= 100) {
            $('.company-Profile_List').eq(0).addClass('appear')
          } else {
            $('.company-Profile_List').eq(0).removeClass('appear')
          }
        } else {
          $('.company-PageTitle_Inner_Title').eq(0).addClass('appear')
          $('.company-Message_Inner').eq(0).addClass('appear')
          $('.sw-Section_HeaderS').eq(0).addClass('appear')
          $('.company-Profile_List').eq(0).addClass('appear')
        }

        // appear
      })
    }
  }
}
</script>
<style scoped>
dd {
    margin-bottom: 0rem;
    margin-left: 0;
}
 a {
    border-bottom-style: none;
  }
  .home>>>.st-Nav_List-en {
    color: #222;
  }

  .home>>> .st-Nav_List-ja {
    color: #222;
  }

  .home>>> .st-Header {
    background-color: #fff;
    border-bottom: 1px solid #ddd;

  }

  .home>>>.recruit font {
    color: #c7000b
  }

  .home>>>.recruit:after {
    transform: scaleX(1) !important;
  }

  @media screen and (min-width: 769px) {

    .company-Profile_List-label{
      width: 38%;text-align: center;
    }
  }

  @media screen and (max-width: 769px) {

    .company-PageTitle{
      padding-top: 0px !important;
      margin-top: -5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/recruit/recruit.vue